import { useLocation } from 'react-router-dom'

export const usePreviousLocation = (): string | null => {
  const location = useLocation()
  const from = location.state?.from ?? null
  return from
}
